export default __webpack_public_path__ + "static/media/DSC_0841.13dee4ab.JPG";